import state from '@ugc-store';

export interface PerimeterX {
  appId: string;
  jsClientSrc: string;
  firstPartyEnabled: boolean;
  vid: string;
  uuid: string;
  hostUrl: string;
  blockScript: string;
}

export const handlePxResponse = (data: PerimeterX, blockedUrl: string, isReloadPage = false): void => {
  try {
    if (!window) return;
    if (!state.isShowPerimeterx) {
      const el = document.querySelector('#px-captcha-wrapper #px-captcha');
      if (el) {
        el.remove();
      }
      state.isShowPerimeterx = true;
    }
    window['_pxBlockedUrl'] = blockedUrl;
    window['_pxAppId'] = `${data.appId}`;
    window['_pxJsClientSr'] = `${state.domains.catalogApi}${data.jsClientSrc}`;
    window['_pxFirstPartyEnabled'] = data.firstPartyEnabled;
    window['_pxVid'] = `${data.vid}`;
    window['_pxUuid'] = `${data.uuid}`;
    window['_pxHostUrl'] = `${data.hostUrl}`;
    window['_pxOnCaptchaSuccess'] = () => {
      state.isShowPerimeterx = false;
      isReloadPage && window.location.reload();
    };
    const script = document.createElement('script');
    script.src = `${state.domains.catalogApi}${data.blockScript}`;
    document.getElementsByTagName('head')[0].appendChild(script);
  } catch (e) {}
};
